import View from './View'

const Container = ({ textUnidade }) => {
  return <View title="Dados Unidade Single Contrato" textUnidade={textUnidade} />
}

export default Container
